import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { convertThenFormat, formatDateTimezon } from "../common-data/Converts";
import UMListingsMobile from "./UMListingsMobile";

const UMListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  const {
    upgradeMemberships,
    upgradeMembershipsLoading,
    upgradeMembershipsError,
  } = useSelector((state) => state.plans);

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  useEffect(() => {
    if (
      upgradeMemberships?.status &&
      upgradeMemberships?.data?.length > 0 &&
      !upgradeMembershipsLoading &&
      !upgradeMembershipsError
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: upgradeMemberships.data,
        pagination:
          upgradeMemberships?.pagination?.length > 0
            ? upgradeMemberships.pagination
            : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [upgradeMemberships, upgradeMembershipsLoading, upgradeMembershipsError]);

  const tbColumns = [
    // {
    //   dataField: "is_upgraded",
    //   text: "plan upgrade",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data icon">
    //         {row?.is_upgraded ? (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-check-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#209216" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    //           </svg>
    //         ) : (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-x-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#E41815" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
    //           </svg>
    //         )}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "user_id",
      text: "member detail",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.user_name || "NA"}
            <br />
            <small className="lowercase underline">
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "upgraded_by",
      text: "added by",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.upgraded_by_name || "NA"} <br />
            <small className="lowercase underline">
              {row?.upgraded_by_mobile || ""}
              <br />
              {row?.upgraded_by_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "is_partial",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "current_subscription_status",
      text: "plan status",
      formatter: (_, row) => {
        const planStatus = row?.current_subscription_status
          ?.replace(/ /g, "_")
          ?.toLowerCase();

        return (
          <>
            <span
              className="tb-data minWidth150 withPadding borderRdius27"
              style={{
                background:
                  planStatus === "active"
                    ? "#379C00"
                    : planStatus === "expiring"
                    ? "#EB8317"
                    : "#D90000",
                color: "#fff",
              }}>
              {row?.current_subscription_status || "NA"}
            </span>

            <br />

            {row?.current_plan_name && (
              <span className="tb-data underline">
                <small>{row.current_plan_name || ""}</small>
              </span>
            )}

            <br />

            {row?.subscription_expiry_days && (
              <span className="tb-data">
                <small>({row.subscription_expiry_days || ""})</small>
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Start/Expire Date",
      formatter: (_, row) => (
        <span className="tb-data minWidth100 underline">
          <small className="gray underline">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </small>
          <br />
          {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
          <br />
          {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
        </span>
      ),
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (_, row) => (
        <span
          className={`tb-data ${row?.is_partial ? "link" : ""}`}
          onClick={() =>
            row?.is_partial
              ? setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "partial_details",
                  partialDetails: row?.payment_details || [],
                }))
              : null
          }>
          {row?.is_partial ? "Partial" : "Full"}
        </span>
      ),
    },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (_, row) => (
        <span className="tb-data">₹{convertThenFormat(row?.price || 0)}</span>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (_, row) => (
        <span className="tb-data">
          {row?.is_partial
            ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
            : "-"}
        </span>
      ),
    },
    {
      dataField: "total_online",
      text: "Online/Cash Amount",
      formatter: (_, row) => (
        <span className="tb-data minWidth150">
          <small>
            ₹
            {convertThenFormat(
              row?.is_partial
                ? row?.partial_total_online
                : row?.total_online || 0
            )}
            / ₹
            {convertThenFormat(
              row?.is_partial ? row?.partial_total_cash : row?.total_cash || 0
            )}
          </small>
        </span>
      ),
    },
  ];

  return (
    <>
      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table hideMobile mt30">
        {upgradeMembershipsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            isFirstColSticky={true}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>

      <div className="lead-logs-card-container only-mobile">
        <UMListingsMobile
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          setModValues={setModValues}
        />
      </div>
    </>
  );
};

export default UMListings;